import { type ValueOf } from '@models/helpers/custom'

export const SettingsQuery = {
  SHOW_SETTINGS: 'show_settings'
} as const

export const TimeFormats = {
  TWELVE_HOURS: 'twelve_hours',
  TWENTY_FOUR_HOURS: 'twenty_four_hours'
} as const
export const DateFormats = {
  EU_DATE_FORMAT: 'eu_date_format',
  US_DATE_FORMAT: 'us_date_format'
} as const
export const NumberSeparators = {
  SPACE: 'space',
  DOT: 'dot',
  COMMA: 'comma'
} as const
export const MFAOperations = {
  LOGIN: 'login',
  PAYMENT: 'payment'
} as const

export type TimeFormatType = ValueOf<typeof TimeFormats>
export type DateFormatType = ValueOf<typeof DateFormats>
export type DecimalsSeparatorType = typeof NumberSeparators.DOT | typeof NumberSeparators.COMMA
export type DigitsSeparatorType = ValueOf<typeof NumberSeparators>
export type NumberSettingsType = {
  decimals_separator: DecimalsSeparatorType;
  digits_separator: DigitsSeparatorType;
}
export type CurrencySettingsType = {
  sign: boolean;
  left_position: boolean;
}
export type MFAOperationsType = ValueOf<typeof MFAOperations>
export type SessionType = {
  session_key: string;
  ip_address: string;
  expire_date: string;
  user_agent: string;
  device: string | null;
  browser: string | null;
  country: string | null;
  city: string | null;
  last_activity: string;
  is_current: boolean;
}

export type NotificationSettingsType = {
  type: {
    email: boolean;
    sms: boolean;
  },
  events: {
    login: boolean;
    payment_error: boolean;
  }
}
